const RUSSIAN_LOCAL_PHONE_REGEXP = /^8\d{10}$/;

export const getPhoneDigits = (phone: string): string => {
  return phone.replace(/\D/g, '');
};

export const isRussianLocalPhoneNumber = (phoneDigits: string): boolean => {
  return RUSSIAN_LOCAL_PHONE_REGEXP.test(phoneDigits);
};

export const normalizeRussianLocalPhoneNumber = (
  phoneDigits: string
): string => {
  if (!isRussianLocalPhoneNumber(phoneDigits)) {
    return phoneDigits;
  }

  return `7${phoneDigits.slice(1)}`;
};

export const normalizeRussianLocalPhoneInput = (phone: string): string => {
  const phoneDigits = getPhoneDigits(phone);
  const normalizedPhoneDigits = normalizeRussianLocalPhoneNumber(phoneDigits);

  if (normalizedPhoneDigits === phoneDigits) {
    return phone;
  }

  return normalizedPhoneDigits;
};
